import { render, staticRenderFns } from "./GameCase.vue?vue&type=template&id=fecb9b1a&scoped=true"
import script from "./GameCase.vue?vue&type=script&lang=js"
export * from "./GameCase.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=fecb9b1a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecb9b1a",
  null
  
)

export default component.exports